import script from "./SgmMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SgmMenu.vue?vue&type=script&setup=true&lang=js"

import "./SgmMenu.vue?vue&type=style&index=0&id=03640114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03640114"]])

export default __exports__